import { TeamSide } from '@collector/shared-domain'

import { getDatabase } from '../instance'
import { Tables } from '../tables'
import { getTable, upsertTableItem } from '../utils'

export type EventSettingsRecord = {
  eventId: number
  teamSideChanged?: boolean
  teamColorsSwitched?: boolean
  invertedParticipants?: boolean
  teamSidePossession?: TeamSide
  shotsCoordinates?: boolean
  assignPlayerOnPitch?: boolean
}

export type EventSettingsRecordUpdate = Omit<EventSettingsRecord, 'eventId'> & {
  eventId?: EventSettingsRecord['eventId']
}

export function upsert(
  eventId: number,
  eventSettings: EventSettingsRecordUpdate,
): Promise<void> {
  const database = getDatabase()

  return upsertTableItem(
    database,
    Tables.EVENT_SETTINGS,
    eventId,
    eventSettings,
  )
}

export function get(eventId: number): Promise<EventSettingsRecord | undefined> {
  const table = getTable(Tables.EVENT_SETTINGS)

  return table.get(eventId)
}

export function remove(eventId: number): Promise<void> {
  const table = getTable(Tables.EVENT_SETTINGS)

  return table.delete(eventId)
}
